import React from 'react';
import { styled } from '@linaria/react';
import { SmoothScrollNavigation } from '@daedalus/atlas/experimental/SmoothScrollNavigation';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
//
const _exp = /*#__PURE__*/() => SkeletonLoader;
const AvailabilityTileSkeleton = /*#__PURE__*/styled(_exp())({
  name: "AvailabilityTileSkeleton",
  class: "a160orhd",
  propsAsIs: true
});
export const Loading = () => {
  return <div>
      <SmoothScrollNavigation itemsGap={'s300'}>
        <AvailabilityTileSkeleton height={76} marginTop={0} />
        <AvailabilityTileSkeleton height={76} marginTop={0} />
        <AvailabilityTileSkeleton height={76} marginTop={0} />
        <AvailabilityTileSkeleton height={76} marginTop={0} />
        <AvailabilityTileSkeleton height={76} marginTop={0} />
      </SmoothScrollNavigation>
    </div>;
};

require("./Loading.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Loading.tsx");